$(document).ready(function () {
  // WPML language-switcher adjustments
  $(".wpml-ls-item-toggle").on("click", function () {
    $(this).toggleClass("active");
    $(".wpml-ls-sub-menu").toggleClass("active");

    if ($(this).hasClass("active")) {
      // Scroll down to language-selection (needed for mobile-menu)
      $(this).closest(".eael-offcanvas-content").animate(
        {
          scrollTop: 1000,
        },
        400
      );
    }
  });

  // Replace mobile-menu burger-button for DARK-theme
  const isCareerHeader = $("#cle-header-bar").hasClass("header-bar-career");
  if (
    $("body").hasClass("page-template-page_dark-color-scheme") ||
    $("body").hasClass("studio-scheme-dark") ||
    isCareerHeader
  ) {
    console.log('setting header-icons to white');
    let fillColor = isCareerHeader ? "#E30613" : "white";
    const burgerButtonSVG =
      '<svg xmlns="http://www.w3.org/2000/svg" width="46" height="34" viewBox="0 0 46 34"><g id="burger_button" data-name="burger button" transform="translate(-1791 -74)"><rect id="Rectangle_6" data-name="Rectangle 6" fill="' +
      fillColor +
      '" width="46" height="3" transform="translate(1791 74)"></rect><rect id="Rectangle_7" data-name="Rectangle 7" fill="' +
      fillColor +
      '" width="46" height="3" transform="translate(1791 89)"></rect><rect id="Rectangle_8" data-name="Rectangle 8" fill="' +
      fillColor +
      '" width="46" height="3" transform="translate(1791 105)"></rect></g></svg>';
    const closeMobileMenuButton =
      '<svg xmlns="http://www.w3.org/2000/svg" width="46" height="34" viewBox="0 0 46 34"><g id="burger_button" data-name="burger button" transform="translate(-1785 -74)"><rect id="Rectangle_6" data-name="Rectangle 6" fill="' +
      fillColor +
      '" width="45" height="3" transform="translate(1793 74) rotate(45)"/><rect id="Rectangle_8" data-name="Rectangle 8" fill="' +
      fillColor +
      '" width="45" height="3" transform="translate(1791 106) rotate(-45)"/></g></svg>';

    $(".cle-mobile-burger-button-container .eael-offcanvas-toggle").html(burgerButtonSVG);
    $(".eael-offcanvas-close").html(closeMobileMenuButton);
  }
});
